import { Directive, Output, EventEmitter } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';
import { Constants } from './constants';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[email][formControlName],[email],[formControl],[email][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: EmailValidatorDirective, multi: true }],
})
export class EmailValidatorDirective implements Validator {
  constructor() {}

  validate(c: AbstractControl): { [key: string]: any } | null {
    let value: string = c.value;

    if (value != null && value !== '') {
      value = value.toUpperCase();
      const regex: RegExp = new RegExp("^[A-Z0-9\\._\\-']+@[A-Z0-9\\._\\-']+$");

      const result = !value.match(regex);
      const response: { [key: string]: any } | null = result ? { email: Constants.EMAIL } : null;

      return response;
    }

    return null;
  }
}
